<template>
  <el-dialog
    class="dialog-entrance-list"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    title="Danh sách ca test đầu vào"
  >
    <table class="table table-bordered table-hover mb-0">
      <thead>
        <tr>
          <th>Loại thi</th>
          <th>Trạng thái</th>
          <th>Thời gian tạo</th>
          <th class="text-center">Hành động</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.exam_type }}</td>
          <td>{{ item.status_text }}</td>
          <td>{{ item.created_at }}</td>
          <td class="text-center">
            <el-tooltip content="Xem chi tiết" placement="top" effect="dark">
              <button
                type="button"
                class="btn-entrance-list-view"
                @click="handleView(item)"
              >
                <i class="fa fa-eye"></i>
              </button>
            </el-tooltip>
          </td>
        </tr>
        <tr v-if="!list.length">
          <td colspan="4" class="text-center text-muted py-3">Không có dữ liệu</td>
        </tr>
      </tbody>
    </table>
    <div slot="footer" class="text-right">
      <el-button class="btn-entrance-list-close" @click="dialogVisible = false">Đóng</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "EntranceListDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    handleView(item) {
      this.$emit("view", item);
    }
  }
};
</script>

<style scoped>
.btn-entrance-list-view {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #0066ff;
  border-radius: 8px;
  background: transparent;
  color: #0066ff;
  cursor: pointer;
  line-height: 1;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.btn-entrance-list-view i {
  font-size: 16px;
  font-weight: 600;
}

.btn-entrance-list-view:hover {
  background-color: rgba(0, 102, 255, 0.08);
  color: #0066ff;
}

.btn-entrance-list-view:focus {
  outline: none;
}

.dialog-entrance-list .btn-entrance-list-close {
  color: #fff;
  background-color: #909399;
  border-color: #909399;
}

.dialog-entrance-list .btn-entrance-list-close:hover {
  color: #fff;
  background-color: #7a7e83;
  border-color: #7a7e83;
}
</style>
